(() => {
  if (window.artkaProductOptionsLoaded) return;
  window.artkaProductOptionsLoaded = true;

  const updateSelection = (input, closeAfterSelection = false) => {
    const selector = input.closest('[data-artka-color-selector]');
    if (!selector) return;

    const label = selector.querySelector('[data-artka-selected-label]');
    const selectedSwatch = selector.querySelector('[data-artka-selected-swatch]');
    const optionSwatch = input.nextElementSibling?.querySelector('.artka-color-option__swatch');
    const error = selector.querySelector('[data-artka-color-error]');
    const disclosure = selector.querySelector('[data-artka-color-disclosure]');

    if (label) label.textContent = input.value;
    if (selectedSwatch && optionSwatch) {
      selectedSwatch.style.background = getComputedStyle(optionSwatch).backgroundColor;
      selectedSwatch.hidden = false;
    }
    if (error) error.hidden = true;
    if (closeAfterSelection && disclosure) disclosure.open = false;
  };

  const syncSelections = (root = document) => {
    root.querySelectorAll('[data-artka-color-selector] .choose_yours_color_property_field:checked')
      .forEach((input) => updateSelection(input));
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.choose_yours_color_property_field')) return;
    updateSelection(event.target, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncSelections());
  } else {
    syncSelections();
  }

  document.addEventListener('shopify:section:load', (event) => syncSelections(event.target));
})();
